module.exports = __webpack_public_path__ + "static/media/honda-checkmark.6a6673bb.svg";